import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a99aaac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, " Rider Edit")
  ])
], -1))
const _hoisted_4 = { class: "col-5 mt-4" }
const _hoisted_5 = { class: "form-floating" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Name", -1))
const _hoisted_7 = { class: "form-floating" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Email", -1))
const _hoisted_9 = { class: "form-floating" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Mobile Number", -1))
const _hoisted_11 = { class: "form-check" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " is buzy ", -1))
const _hoisted_13 = { class: "form-check" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " availability ", -1))
const _hoisted_15 = { class: "form-floating" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "pending", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "approve", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Block", -1))
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Status", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.rider_name) = $event)),
              type: "text",
              class: "form-control",
              placeholder: "Per Unit Price",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.rider_name]
            ]),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "email",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.rider_email) = $event)),
              class: "form-control",
              placeholder: "Base Price",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.rider_email]
            ]),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.rider_mobile_no) = $event)),
              class: "form-control",
              placeholder: "Base Unit",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.rider_mobile_no]
            ]),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.is_buzy) = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault"
            }, null, 512), [
              [_vModelCheckbox, $setup.data.is_buzy]
            ]),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.availability_status) = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault"
            }, null, 512), [
              [_vModelCheckbox, $setup.data.availability_status]
            ]),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.status) = $event)),
              class: "form-control",
              required: ""
            }, _hoisted_19, 512), [
              [_vModelSelect, $setup.data.status]
            ]),
            _hoisted_20
          ]),
          _hoisted_21
        ], 32)
      ])
    ])
  ]))
}